export default __webpack_public_path__ + "static/media/Feature4.3fbc0ef5.svg";